import { Component, OnInit, OnChanges, SimpleChanges, Input,ViewChild } from '@angular/core';
import {BaseChartDirective} from "ng2-charts/index";

@Component({
    selector: 'issues-graph-widget',
    templateUrl: './issues-graph-widget.component.html',
    styleUrls: ['./issues-graph-widget.component.scss']
})
export class IssuesGraphWidgetComponent implements OnInit {
    @ViewChild(BaseChartDirective) chart: BaseChartDirective
    @Input() labels;
    @Input() data;
    @Input() flag;  // Use to launch ngOnChanges because changes are not handed properly by ChartJS and we have to
                    // update it manually

    //  Doughnut chart
    // -----------------------------------
    private totalIssues;

    doughnutData = {};
    doughnutColors = [{
        borderColor: [
            '#5bc0de',
            'orange',
            'purple',
            'grey',
            '#13CE66',
            'red',
            '#428BCA',
            'darksalmon',
            'lightgrey',
            'brown',
            'beige',
            'darkcyan',
            'black'
        ],
        backgroundColor: [
            '#5bc0de',
            'orange',
            'purple',
            'grey',
            '#13CE66',
            'red',
            '#428BCA',
            'darksalmon',
            'lightgrey',
            'brown',
            'beige',
            'darkcyan',
            'black'
        ],
    }];
    doughnutOptions = {
        responsive: true
    };

    constructor() { }

    ngOnInit() {
        this.doughnutData  = {
            labels: this.labels,
            datasets: [{data: this.data}]
        };
        this.totalIssues = this.data.reduce((a,b) => a+b, 0);
    }

    ngOnChanges(changes: SimpleChanges) {
        if (this.chart.chart) {
            this.chart.chart.update();
        }
        this.totalIssues = this.data.reduce((a,b) => a+b, 0);
    }

}



// WEBPACK FOOTER //
// ./src/app/routes/common/issues-graph-widget/issues-graph-widget.component.ts